import { NOTIFYER_PIPEDRIVE_URL } from "../../redux/reducers/authSlice";
import AuthStatusScreen from "./AuthStatusScreen";

export default function AuthorizationRequiredScreen() {
  return (
    <AuthStatusScreen
      title="Connect Whatsable"
      description="Link Pipedrive with Notifyer to use WhatsApp chat inside your CRM."
    >
      <a
        href={NOTIFYER_PIPEDRIVE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-7 inline-flex w-full items-center justify-center rounded-lg bg-[#25D366] px-4 py-3 text-sm font-semibold text-white transition hover:bg-[#20bd5a]"
      >
        Connect Whatsable
      </a>
      <p className="mt-4 text-xs text-gray-400">
        After setup, reload this app from Pipedrive.
      </p>
    </AuthStatusScreen>
  );
}
